import React from 'react';
import {
  NewReadingGapPanel,
  NewReadingGapPanelProps,
} from './NewReadingGapPanel';
import ButtonShowPanel from 'components/base/panel/buttonshowpanel';
import { t, Trans } from '@lingui/macro';
import { ButtonProps } from 'components/base/button/button';

export const ButtonShowNewReadingGapPanel = (
  props: Omit<NewReadingGapPanelProps, 'hidePanel'> & {
    panelRef?: React.RefObject<HTMLElement>;
    buttonProps?: ButtonProps;
  }
) => {
  const { buttonProps, panelRef, ...newReadingGapPanelProps } = props;
  return (
    <ButtonShowPanel
      iconType="icon-space-bar"
      name="new-reading-gap-panel"
      title={t`Add reading gap`}
      panelContent={({ hidePanel }) => (
        <NewReadingGapPanel
          {...newReadingGapPanelProps}
          hidePanel={hidePanel}
        />
      )}
      panelRef={props.panelRef}
      {...buttonProps}
    >
      <Trans>Add reading gap</Trans>
    </ButtonShowPanel>
  );
};
